
import { useNavigate, useParams } from "react-router-dom";
import { CaiSection, Section } from "../components/styled/Containers.style";
import { selectCommunicationData } from "../store";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { composeUrl } from "../utils/utils";
import { useState } from "react";
import { PATHS } from "../routes/CaiExperienceRouter";
import { saveCommunicationAct } from "../store/communication-data/actions";
import { CommunicationType } from "../types/communication/communicationDataType";
import PageContainerCmp from "./PageContainerCmp";
import RadioOptionsCmp from "../components/radio/RadioOptionsCmp";
import { booleanRadioOptions, BoolStringEnum, getValueLabelOptions, ValueLabelOption } from "../types/commonTypes";
import { VPercentageSeparator, Vspace } from "../components/styled/Separators.style";

/* istanbul ignore next */
const CondizioniVeicoloPage = () => {
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    let { token } = useParams();

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData

    const [airbagScoppiati, setAirbagScoppiati] = useState<BoolStringEnum | undefined>(communication.airbagScoppiati)
    const [veicoloMarciante, setVeicoloMarciante] = useState<BoolStringEnum | undefined>(communication.veicoloMarciante)

    const goToNextStepHandler = () => {
        let _pathname = composeUrl(token, PATHS.BACH_BAREME_DYNAMIC)
        if (communication.disable_step_10 === true) {
            _pathname = composeUrl(token, PATHS.Q1)
        }

        /* istanbul ignore next */
        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                airbagScoppiati,
                veicoloMarciante
            }),
            callback: () => navigate(_pathname)
        })
        )
    }

    const isTrctAirbagStepValid = (
        (airbagScoppiati === BoolStringEnum.Y || airbagScoppiati === BoolStringEnum.N) && 
        (veicoloMarciante === BoolStringEnum.Y || veicoloMarciante === BoolStringEnum.N)
    )

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.CONDIZIONI_VEICOLO}
                hasPaddingX
                nextDisabled={!isTrctAirbagStepValid}
            >
                <Section>
                    <PageTitle>Condizioni del veicolo</PageTitle>
                    <Vspace qty={2.5}></Vspace>
                </Section>

                <CaiSection className="cai-section">
                    <RadioOptionsCmp
                        horizontal
                        otpionsLabel="Qualcuno degli airbag è esploso?"
                        subLabelElement={<>
                            <Vspace qty={0.5}></Vspace>
                        </>}
                        options={booleanRadioOptions}
                        value={getValueLabelOptions(booleanRadioOptions, airbagScoppiati)}
                        className={'cai airbag-scoppiati'}
                        onChange={(newChoise: ValueLabelOption<BoolStringEnum>) => setAirbagScoppiati(newChoise.value)}
                    />
                    <Vspace qty={1}></Vspace>
                </CaiSection>

                <VPercentageSeparator></VPercentageSeparator>

                <CaiSection className="cai-section">
                    <Vspace qty={1}></Vspace>
                    <RadioOptionsCmp
                        horizontal
                        otpionsLabel="Il veicolo è marciante?"
                        options={booleanRadioOptions}
                        subLabelElement={<>
                            <Vspace qty={1}></Vspace>
                            <TextDefault>Questo ci aiuta a capire se il danno interessa anche il sistema di sterzo</TextDefault>
                            <Vspace qty={0.5}></Vspace>
                        </>}
                        value={getValueLabelOptions(booleanRadioOptions, veicoloMarciante)}
                        className={'cai veicolo-marciante'}
                        onChange={(newChoise: ValueLabelOption<BoolStringEnum>) => setVeicoloMarciante(newChoise.value)}
                    />
                </CaiSection>

            </PageContainerCmp>
        </>

    )
}

export default CondizioniVeicoloPage